import React from "react";

const Printer = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
    <path fill="#96CEF6" fillOpacity=".75" d="M17.5 5.625h-1.875v-3.75H4.375v3.75H2.5a1.25 1.25 0 00-1.25 1.25v6.25a1.25 1.25 0 001.25 1.25h1.875v3.75h11.25v-3.75H17.5a1.25 1.25 0 001.25-1.25v-6.25a1.25 1.25 0 00-1.25-1.25zm-11.875-2.5h8.75v2.5h-8.75v-2.5zm8.75 13.75h-8.75v-6.25h8.75v6.25zm3.125-3.75h-1.875v-3.75H4.375v3.75H2.5v-6.25h15v6.25z" />
  </svg>
);

export default Printer;
